import { defineComponent, onMounted, ref } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        list: definePropType(Array),
        total: {
            type: Number
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var load = function load() {
            emit("load");
        };
        var singleAdd = function singleAdd(item) {
            if (!selectData.value.find(function(i) {
                return i.adv_id === item.adv_id;
            })) {
                selectData.value.push(item);
            }
        };
        var singleDelete = function singleDelete(index) {
            selectData.value.splice(index, 1);
        };
        var handleDisabled = function handleDisabled(item) {
            return !!selectData.value.find(function(i) {
                return i.adv_id === item.adv_id;
            });
        };
        var allAdd = function allAdd() {
            emit("add");
        };
        var handleAllAdd = function handleAllAdd(list) {
            list.forEach(function(item) {
                if (!selectData.value.find(function(i) {
                    return i.adv_id === item.adv_id;
                })) {
                    selectData.value.push(item);
                }
            });
        };
        var allDelete = function allDelete() {
            selectData.value = [];
        };
        var selectData = ref([]);
        onMounted(function() {});
        return {
            selectData: selectData,
            load: load,
            singleAdd: singleAdd,
            singleDelete: singleDelete,
            handleDisabled: handleDisabled,
            allAdd: allAdd,
            allDelete: allDelete,
            handleAllAdd: handleAllAdd
        };
    }
});
